/**
 * IMPORTANT! Do not use any services/composables here! (other than the ones defined in the context).
 *
 * This redirect handler should be used solely to determine whether user should be redirected
 * to a certain place or not, based on the application state, which is passed into the exported
 * function as first argument.
 *
 * Only imports that help to determine the redirect are allowed here (like consts or moment).
 */

import { replaceWithResolvedRoute } from '../utils/replace-with-resolved-route'

import type { RedirectContext } from '../types'

export const onboardingFinishedRedirect = ({ onboardingFinished, router, logger }: RedirectContext): unknown => {
  if (onboardingFinished) {
    logger.debug('onboarding finished! >>> onboarding-invites')
    return replaceWithResolvedRoute(router, { name: 'onboarding-invites' })
  }
}
